<template>
  <div class="vertical-products">
      <div class="vertical-products-list">
          <ProductCardVertical v-for="(product, index) in products" :key="index" :product="product"></ProductCardVertical>
      </div>
  </div>
</template>

<script>
    import ProductCardVertical from '../ProductCardVertical.vue';

    export default {
        components: { ProductCardVertical },

        props: ['products'],

        data() {
            return {
                products: [],
            };
        },

        created() {

        },

        methods: {

        },
    };
</script>
